import Cookies from 'universal-cookie';

const cookies = new Cookies();

class Auth {
  authenticated: boolean;

  constructor() {
    this.authenticated = (cookies.get('token')) ? true : false;
  }
  
  login(cb?: () => void){
    this.authenticated = true;
    cb && cb();
  }

  logout(cb?: () => void) {
    this.authenticated = false;
    cb && cb();
  }

  isAuthenticated() {
    return this.authenticated;
  }
}

const MyAuth = new Auth();

export default MyAuth;